// extracted by mini-css-extract-plugin
export default {"list":"Settings_list__DL7TN","colorButtons":"Settings_colorButtons__lhHL4"};